export const staticWinners = [
  {
    name: "Max Schulte: Teacher and Art Interventionist", // business name
    logo: require("@static/businessLogos/MaxSchulteInteractiveMediaArtist.png"), // business logo
    winners: {
      main: {
        name: "Winner NAME",
        address: "Winner ADDRESS",
        prize: "100$",
      },
      mentions: [
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
      ],
      items: [],
    },
  },
  {
    name: "Meridian Stories", // business name
    logo: require("@static/businessLogos/meridianstories.png"), // business logo
    winners: {
      main: {
        name: "Winner NAME",
        address: "Winner ADDRESS",
        prize: "100$",
      },
      mentions: [
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
      ],
      items: [
        {
          logo: require("@static/error-logo.png"),
          itemName: "item NAME",
          winnerName: "ITEM WINNER",
          address: "Winner ADDRESS",
        },
      ],
    },
  },
  {
    name: "Knowledgeflow Foundation", // business name
    logo: require("@static/businessLogos/KnowledgeFlow.png"), // business logo
    winners: {
      main: {
        name: "Winner NAME",
        address: "Winner ADDRESS",
        prize: "100$",
      },
      mentions: [
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
      ],
      items: [
        {
          logo: require("@static/error-logo.png"),
          itemName: "item NAME",
          winnerName: "ITEM WINNER",
          address: "Winner ADDRESS",
        },
        {
          logo: require("@static/error-logo.png"),
          itemName: "item NAME",
          winnerName: "ITEM WINNER",
          address: "Winner ADDRESS",
        },
        {
          logo: require("@static/error-logo.png"),
          itemName: "item NAME",
          winnerName: "ITEM WINNER",
          address: "Winner ADDRESS",
        },
      ],
    },
  },
  {
    name: "Porter Airlines", // business name
    logo: require("@static/businessLogos/Porter.jpg"), // business logo
    winners: {
      main: {
        name: "Winner NAME",
        address: "Winner ADDRESS",
        prize: "100$",
      },
      mentions: [
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
      ],
      items: [
        {
          logo: require("@static/error-logo.png"),
          itemName: "item NAME",
          winnerName: "ITEM WINNER",
          address: "Winner ADDRESS",
        },
      ],
    },
  },
  {
    name: "Robotics For All", // business name
    logo: require("@static/businessLogos/roboticsforall.png"), // business logo
    winners: {
      main: {
        name: "Winner NAME",
        address: "Winner ADDRESS",
        prize: "100$",
      },
      mentions: [
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
      ],
      items: [
        {
          logo: require("@static/error-logo.png"),
          itemName: "item NAME",
          winnerName: "ITEM WINNER",
          address: "Winner ADDRESS",
        },
      ],
    },
  },
  {
    name: "Energie Academie", // business name
    logo: require("@static/businessLogos/ENERGIACADEMIE.png"), // business logo
    winners: {
      main: {
        name: "Winner NAME",
        address: "Winner ADDRESS",
        prize: "100$",
      },
      mentions: [
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
        {
          name: "Winner NAME",
          address: "Winner ADDRESS",
        },
      ],
      items: [
        {
          logo: require("@static/error-logo.png"),
          itemName: "item NAME",
          winnerName: "ITEM WINNER",
          address: "Winner ADDRESS",
        },
      ],
    },
  },
  {
    name: "Others", // business name
    logo: require("@static/eventResults/img_08-others.png"), // business logo
    items: [
      {
        logo: require("@static/raffle/items/ORGANICCOTTONU-SACU-Do-U(Black&White).png"),
        itemName: "Cotton Shoulder Sling",
        partnerName: "building-U",
        partnerLogo: require("@static/raffle/partners/building-U.png"),
        winners: [
          {
            winnerName: "Winner 1 Name here",
            address: "Winner 1 Address",
          },
          {
            winnerName: "Winner 2 Name here",
            address: "Winner 2 Address",
          },
          {
            winnerName: "Winner 3 Name here",
            address: "Winner 3 Address",
          },
        ],
      },
      {
        logo: require("@static/raffle/items/UW_hoodie.png"),
        itemName: "Hoodie (black)",
        partnerName: "Waterloo University",
        partnerLogo: require("@static/raffle/partners/waterloouni.png"),
        winners: [
          {
            winnerName: "Winner 1 Name here Winner 1 Name here",
            address: "Winner 1 Address",
          },
          {
            winnerName: "Winner 2 Name here",
            address: "Winner 2 Address",
          },
          {
            winnerName: "Winner 3 Name here",
            address: "Winner 3 Address",
          },
        ],
      },
      {
        logo: require("@static/raffle/items/savethefrogwhite.png"),
        itemName: "T-Shirt",
        partnerName: "SavetheFrogs!",
        partnerLogo: require("@static/raffle/partners/savetheFrogs.png"),
        winners: [
          {
            winnerName: "Winner 1 Name here",
            address: "Winner 1 Address",
          },
        ],
      },
    ],
  },
];
